/**
 * Return the breakpoint relative to the window inner width
 * @param {String} windowWidth Inner width of the window
 * @returns {String} Breakpoint value
 */
const getDeviceBreakpoint = (windowWidth) => {
    let breakPoint = '';
    if (windowWidth < 992) {
        breakPoint = 'xs';
    } else if (windowWidth < 1200) {
        breakPoint = 'md';
    } else {
        breakPoint = 'lg';
    }
    return breakPoint;
};

export default getDeviceBreakpoint;